import { useMutation } from 'Data/Api.js'

import mutation from './mutation-delete-connection.graphql.js'

export default function useListItemDataOnActionCancelOAuth2AuthorizationCodeConnection(
  props,
  data,
  reExecuteQuery
) {
  let [, executeMutation] = useMutation(mutation)

  return async function onSubmit({ value, args, change }) {
    if (!value.connecting) return

    try {
      args.authWindow.current?.close()
      args.authWindow.current = null

      // delete newly created connection as not used anyway
      await executeMutation({
        connection_id: value.connection_id,
      })
    } catch (_) {
    } finally {
      setTimeout(() => {
        change(next => {
          next.connecting = false
        })
      }, 100)
    }
  }
}
